import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Variations = ({
  onClose,
  onVariationSelection,
  variations,
  variationType,
}) => {
  const { t } = useTranslation();

  return (
    <div className="variation_modal">
      <div className="close" onClick={onClose}></div>
      <div className="modal_header">
        {variations[0].color ? t("color") : t("container")}
      </div>
      <div className="modal_content">
        {variations.map((item, index) => (
          <div className="variation" key={index}>
            <div className="label" onClick={() => onVariationSelection(index)}>
              {variationType === "color" && (
                <div
                  className="color"
                  style={{ backgroundColor: item.color }}
                ></div>
              )}
              {item.value_label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Variations;
